import type { UndecoratedProfile } from '@flemingmetrics/api-client';

export function getProfileLabels({ firstname, lastname }: UndecoratedProfile) {
  return {
    name: `${firstname}${lastname ? ` ${lastname}` : ''}`,
    initials:
      `${firstname.slice(0, 1)}${lastname?.slice(0, 1) || ''}`.toUpperCase(),
  };
}
